import template from './main.html';
import controller from './main.controller.js';

const menuMainComponent = {
  restrict: 'E',
  controller,
  template
};

export default menuMainComponent;



/** WEBPACK FOOTER **
 ** ./client/app/components/menu/main/main.component.js
 **/